// extracted by mini-css-extract-plugin
export default {"slideItem":"index_slideItem_fLebK","slides":"index_slides_f803K"};